import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";

const Hakkimizda = lazy(() => import("../pages/hakkimizda/page"));
const Hizmetler = lazy(() => import("../pages/hizmetler/page"));
const Urunler = lazy(() => import("../pages/urunler/page"));
const UrunDetail = lazy(() => import("../pages/urunler/detail/page"));
const Referanslar = lazy(() => import("../pages/referanslar/page"));
const Blog = lazy(() => import("../pages/blog/page"));
const BlogDetail = lazy(() => import("../pages/blog/detail/page"));
const Iletisim = lazy(() => import("../pages/iletisim/page"));
const SSS = lazy(() => import("../pages/sss/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const Fallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#1a1a1a]">
    <div className="w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

const wrap = (el: React.ReactElement) => (
  <Suspense fallback={<Fallback />}>{el}</Suspense>
);

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/hakkimizda", element: wrap(<Hakkimizda />) },
  { path: "/hizmetler", element: wrap(<Hizmetler />) },
  { path: "/urunler", element: wrap(<Urunler />) },
  { path: "/urunler/:slug", element: wrap(<UrunDetail />) },
  { path: "/referanslar", element: wrap(<Referanslar />) },
  { path: "/blog", element: wrap(<Blog />) },
  { path: "/blog/:slug", element: wrap(<BlogDetail />) },
  { path: "/iletisim", element: wrap(<Iletisim />) },
  { path: "/sss", element: wrap(<SSS />) },
  { path: "*", element: wrap(<NotFound />) },
];

export default routes;
